import './PopupLoading.css';

const PopupLoading = () => {
  return <div className="popup_loading"> 
    <div className="popup_content">
      <div className="icon"><img alt={process.env.REACT_APP_NAME} src="/assets/images/logo_white.png" /></div>
      {/*<h2>{i18n.t('loading')}</h2>*/}
    </div>
  </div>;
};

export default PopupLoading;